export const SITE_NAME = "MCVerse";
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://www.mcverse.city"
).replace(/\/+$/, "");
export const DEFAULT_TITLE = "MCVerse City Survival Minecraft Featuring Forever World";
export const DEFAULT_DESCRIPTION =
  "Minecraft Survival for years to come on a No-Reset World. Large Claims, Free 150k Claim blocks.";
export const DEFAULT_IMAGE = "/logo192.png";
export const HOME_IMAGE = "/imgs/player-builds/2024-01-17_19.58.54.jpg";

export function toAbsoluteUrl(pathOrUrl) {
  if (!pathOrUrl) {
    return new URL(DEFAULT_IMAGE, SITE_URL).toString();
  }

  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl;
  }

  const normalizedPath = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return new URL(normalizedPath, SITE_URL).toString();
}

export function summarizeText(value, maxLength = 180) {
  if (!value) {
    return DEFAULT_DESCRIPTION;
  }

  const normalized = String(value)
    .replace(/[*_`>#-]/g, " ")
    .replace(/\[[^\]]*\]\([^)]+\)/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) {
    return DEFAULT_DESCRIPTION;
  }

  if (normalized.length <= maxLength) {
    return normalized;
  }

  return `${normalized.slice(0, maxLength - 1).trim()}...`;
}
